import * as React from 'react';

import SentryProvider from 'components/SentryProvider';
import Footer from 'components/footer/Footer';

type Props = {
  children: React.ReactNode,
  showFooter: boolean
};

class GlobalLayout extends React.PureComponent<Props> {
  render() {
    const { children, showFooter } = this.props;
    return (
      <div>
        <SentryProvider />
        {children}
        {
          showFooter &&
            <Footer />
        }
      </div>
    );
  }
}

export default GlobalLayout;
